<template>
  <div class="dropzone-gallery rounded mt-5 p-3">
    <div class="row dropzone-previews ma-3">
      <div
        v-for="(file, index) in files"
        :key="index"
        :v-if="repo == 'documents' || repo == 'contracAttachments'"
        class="col-6 mx-1 col-md-3"
      >
        <div
          class="col-12 card"
          :style="{ background: 'url(' + file.preview + ')' }"
        >
          <i
            class="fas fa-trash text-danger"
            @click="deleteFile(file, index)"
          ></i>
        </div>
        <div class="col-12 px-0">
          <label for="">نوع مدرک *</label>
          <multiselect
            required
            :rules="[(v) => !!v || 'وارد کردن نوع مدرک الزامی میباشد']"
            v-model="documentTypeId[index]"
            openDirection="below"
            :options="
              documentTypesItem && documentTypesItem.length
                ? documentTypesItem
                : documentsTypes
            "
            selectLabel="انتخاب کنید"
            selectedLabel="انتخاب شده"
            deselectLabel="حذف انتخاب"
            @search-change="requestForResults('asyncDocumentType', $event)"
            placeholder=" نوع مدرک را جستجو کنید"
            :close-on-select="true"
            track-by="id"
            :addable="false"
            :taggable="false"
            :multiple="false"
            :custom-label="label"
          >
            <template slot="option" slot-scope="props">
              <div class="option__desc pr-5">
                <!-- v-for="(category , index) in props.option.categories" -->
                <span class="option__title pr-4">{{ props.option.value }}</span>
              </div>
            </template>
            <span slot="noResult">موردی یافت نشد</span>
            <span slot="noOptions">لیست خالی است</span>
          </multiselect>
        </div>
        <div class="col-12 px-0">
          <label for="">توضیحات</label>
          <v-textarea
            dense
            v-model="documentDescription[index]"
            outlined
            class="mt-1"
          >
          </v-textarea>
        </div>
      </div>
    </div>
    <vue-dropzone
      :id="randomId"
      @vdropzone-file-added="emitUploadDeleteStarted"
      @vdropzone-files-added="emitUploadDeleteStarted"
      @vdropzone-total-upload-progress="changeProgress"
      @vdropzone-success="successUpload"
      @vdropzone-error="uploadFailed"
      :options="dropzoneOptions"
    ></vue-dropzone>
    <div class="progress my-2" v-if="uploadProgress">
      <div
        class="progress-bar"
        role="progressbar"
        :style="{ width: uploadProgress + '%' }"
        :aria-valuenow="uploadProgress"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import asyncLoadMixin from '@/core/mixins/asyncLoadMixin';
import { RepoFactory } from '@/baseRepository/Factory';
const documentTypesRepository = () => RepoFactory.get('documentTypes');
import Helper from '@/core/helpers';

export default {
  name: 'DropzoneUploader',
  mixins: [asyncLoadMixin],
  components: {
    Multiselect,
  },
  props: {
    repo: {
      required: true,
      type: String,
    },
    filesToEdit: {},
    documentsTypes: {
      type: Array,
      default: [],
    },
  },
  data() {
    return {
      randomId: null,
      deleting: false,
      uploadProgress: 0,
      dropzoneOptions: {
        // parallelUploads: 2,
        url: this.getDropZoneUrl(),
        headers: {},
        params: {
          FolderId: 1,
        },
        dictDefaultMessage:
          'یک یا چند فایل را انتخاب کنید یا فایل ها را اینجا رها کنید',
      },
      files: [],
      fileIds: [],
      documentTypeId: [],
      documentDescription: [],
      galleryWasEmpty: false,
      documentTypesItem: [],
    };
  },
  created() {
    this.randomId = `${Math.random(10) + Math.random(10)}`;
    this.filesToEdit;
    if (this.filesToEdit) {
      if (this.repo == 'documents') {
        let tempFilesToEdit = [];
        tempFilesToEdit.push(this.filesToEdit);
        tempFilesToEdit;
        this.files = tempFilesToEdit.map((document) => {
          this.fileIds.push(document.file.fileId);
          this.documentDescription.push(document.description);
          this.documentTypeId.push({
            id: document.documentTypeId,
            value: document.documentTypeName,
          });
          this.documentTypeId;
          return {
            preview: document.file.fileUrl,
            id: document.file.fileId,
          };
        });
      } else if (this.repo == 'contracAttachments') {
        this.files = this.filesToEdit.map((document) => {
          this.fileIds.push(document.file.fileId);
          this.documentDescription.push(document.description);
          this.documentTypeId.push({
            id: document.documentTypeId,
            value: document.documentTypeTitle,
          });
          this.documentTypeId;
          return {
            preview: document.file.fileUrl,
            id: document.file.fileId,
          };
        });
      }
    }
  },
  computed: {
    baseDomain() {
      return this.$store.getters.urls.file;
    },
    employeeBaseUrl() {
      return this.$store.getters.employeeBaseUrl;
    },
  },
  methods: {
    label(object) {
      return ` ${object.value}`;
    },
    asyncDocumentType(query) {
      if (query && query.length >= 3) {
        const param = {
          key: query,
        };
        documentTypesRepository()
          .filterDocumentTypes(this.employeeBaseUrl, {}, param)
          .then((res) => {
            this.documentTypesItem = res.data;
          })
          .catch((error) => {
            Helper.handleErrors(error, this);
          });
      }
    },
    emitUploadDeleteStarted() {
      this.$emit('uploadDeleteStarted');
    },
    getDropZoneUrl() {
      switch (this.repo) {
        case 'document':
          return this.$store.getters.urls.file + '/api/v1/files';

        default:
          return this.$store.getters.urls.file + '/api/v1/files';
      }
    },
    deleteFile(fileToRemove, index) {
      this.files.splice(index, 1);
      this.fileIds.splice(index, 1);
      this.documentTypeId.splice(index, 1);
      this.documentDescription.splice(index, 1);
    },
    changeProgress(totaluploadprogress, totalBytes, totalBytesSent) {
      totaluploadprogress, totalBytes, totalBytesSent;
      this.uploadProgress = totaluploadprogress;
    },
    uploadFailed(file, message, xhr) {
      this.uploadProgress = 0;
    },
    successUpload(file, response) {
      this.uploadProgress = 0;
      this.fileIds.push(response.fileId);
      this.files.push({
        preview: file.dataURL,
        id: response.fileId,
      });
    },
  },
};
</script>

<style lang="scss">
.dz-preview {
  display: none !important;
}
.dropzone-gallery {
  .card {
    height: 6rem;
    background-position: center center !important;
    background-repeat: no-repeat !important;
    background-size: cover !important;
    position: relative;
    background-color: #eee;
    .fa-trash {
      cursor: pointer;
      font-size: 1.4em;
      position: absolute;
      top: 15px;
      left: 25px;
    }
  }
  /*.gallery-uploader-inner {*/
  background-color: #eee;
  /*}*/
  width: 100%;
  height: auto;
}
</style>
